export default __webpack_public_path__ + "static/media/yuukke.33356e74.png";